import * as Company from '@/services/company';
import * as User from '@/services/user';
import { get } from 'lodash';

const MODULE_W2P = 'Web2Print';
const MODULE_BLUEBOX = 'BLUEBOX';

export default {
  namespaced: true,

  state: {
    current: {
      company: null,
      email: '',
      first_name: '',
      last_name: '',
      status: '',
      role: {},
      modules: []
    }
  },

  getters: {
    company: state => {
      return get(state.current, 'company', { name: '' });
    },

    currentUser: state => {
      return state.current;
    },

    isAdmin: state => {
      let result = false;

      const roleName = get(state, 'current.role.name', '');
      if (roleName === User.ROLE_ADMIN) {
        result = true;
      }

      return result;
    },

    hasModuleBluebox: state => {
      if (!state.current.hasOwnProperty('modules')) {
        return false;
      }

      return state.current.modules.some(item => item.module.name === MODULE_BLUEBOX);
    },

    hasModuleW2P: state => {
      if (!state.current.hasOwnProperty('modules')) {
        return false;
      }

      return state.current.modules.some(item => item.module.name === MODULE_W2P);
    },

    hasModules: state => {
      if (!state.current.hasOwnProperty('modules')) {
        return {};
      }

      const result = [];

      state.current.modules.forEach(item => {
        result.push(item.module);
      });

      return result;
    }
  },

  mutations: {
    SET_CURRENT_USER(state, payload) {
      Object.assign(state.current, payload);
    },

    UPDATE_CURRENT_USER(state, payload) {
      const user = new User.User(payload);
      Object.assign(state.current, user);
    },

    SET_COMPANY(state, payload) {
      const current = Object.assign({}, state.current.company);
      state.current.company = new Company.Company(Object.assign({}, current, payload));
    }
  },

  actions: {
    async GET_CURRENT_USER({ commit }) {
      try {
        const response = await User.getMe();
        commit('SET_CURRENT_USER', response.data);
      } catch (error) {
        throw new Error(error);
      }
    },

    async UPDATE_COMPANY({ commit }, payload) {
      try {
        const response = await Company.updateCompanyById(payload.id, payload);
        commit('SET_COMPANY', response.data);
        return response;
      } catch (error) {
        throw new Error(error);
      }
    },

    async UPDATE_USER_BY_ID({ commit }, payload) {
      try {
        const response = await User.updateUserById(payload.id, payload);
        const data = get(response, 'data');
        if (data) {
          commit('UPDATE_CURRENT_USER', data);
        }
        return response;
      } catch (error) {
        throw new Error(error);
      }
    }
  }
};

export const MODULE_NAME = 'user';
